module.exports = __webpack_public_path__ + "media/images/icon_list/notification-94e913209b705e7668c12e6c516895d1.svg";